import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContent } from "../app/ContentContext";

export default function Header() {
  const { header } = useContent();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleNavigate = (path: string) => {
    if (path === "#contact") {
      setTimeout(() => {
        const el = document.getElementById("contact-section");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 50);
    } else {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 50);
    }

    handleClose();
  };
  const menuItems = header.menuItems;

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "common.white",
        color: "secondary.main",
        boxShadow: "0 1px 12px rgba(7, 73, 116, 0.1)",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", py: 0.5 }}>
        <MenuItem
          onClick={() => handleNavigate("/")}
          sx={{ borderRadius: 2, px: 1 }}
        >
          <img
            src="/logo.webp"
            alt="Stavanger ØNH"
            style={{ height: "60px" }}
          />
        </MenuItem>
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 0.5 }}>
          {menuItems.map((item) => (
            <Button
              key={item.label}
              onClick={() => handleNavigate(item.path)}
              sx={{
                color: "secondary.main",
                "&:hover": {
                  backgroundColor: "rgba(24, 174, 172, 0.1)",
                  color: "primary.main",
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>

        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton onClick={handleOpen} sx={{ color: "secondary.main" }}>
            <MenuIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {menuItems.map((item) => (
              <MenuItem
                key={item.label}
                onClick={() => handleNavigate(item.path)}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
